import React from 'react';
import ReactDOM from 'react-dom';
import './EncourageSignup.scss';
import { useModal } from '../../ModalManager';
import { DisableBodyScroll } from '../../../../hooks/useDisableBodyScroll';
import { isBot } from '../../../../libs/helper';



const EncourageSignup = ({handleClose=()=>{}}) => {
    const { openModal } = useModal();
    const handleSignup = (e) => {
        openModal('Signup', {lockedAction : 'ENCOURAGE_SIGNUP'});
    }
    if (isBot) return null; // Ne pas afficher pour les bots

    return ReactDOM.createPortal(
        <div className="encourage-signup-container">
            <DisableBodyScroll/>
            <div className="encourage">
                <h1><b>Rejoignez</b> <br/> la communauté</h1>
                <p>C’est gratuit, rapide, anonyme.</p>
                <ul>
                    <li><span>🔥</span> Contenus hot et non censurés</li>
                    <li><span>🚫</span> Navigation sans limites</li>
                    <li><span>🧑‍🤝‍🧑</span> Accès à la page “Membres”</li>
                    <li><span>💬</span> Likez, commentez... attirez l’attention</li>
                    <li><span>🔐</span> Discuter en privé, en toute liberté</li>
                    <li><span>🟢</span> 150 000 membres actifs en ce moment</li>
                </ul>
                <div className="encourage-footer">
                    <button className="encourage-button" onClick={handleSignup}>Je rejoins Voissa</button>
                    <button className="quit" onClick={handleClose}>Plus tard</button>
                </div>
            </div>
        </div>
    ,
    document.body);
}

export default EncourageSignup;